import { makeStyles, css } from '@conexasaude/conexa-hero'
import { isMIUI } from 'react-device-detect'
import noise from '@/assets/noise.png'
import { IS_PRODUCTION } from '@/constants'

const headerMUIU = isMIUI ? '48px' : '32px'

const useStyles = makeStyles({
  container: theme => css`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 35%;
    @media screen and (max-width: ${theme.grid.breakpoint['2xl']}) {
      width: 60%;
      @media screen and (max-width: ${theme.grid.breakpoint.lg}) {
        width: 100%;
        min-height: 100vh;
      }
    }
    @media screen and (max-width: ${theme.grid.breakpoint.sm}) {
      min-width: 90%;
    }
  `,

  content: css`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  footer: ({ spacing }) => css`
    text-align: center;
    display: flex;
    flex-direction: column;
    margin-bottom: ${spacing.xs};
    align-items: center;
    span:last-child {
      margin-top: ${spacing.xs};
    }
  `,

  backgroundContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
  `,

  backgroundContainerTitle: theme => css`
    text-align: center;
    padding: 0 ${theme.spacing.md};
    margin-top: ${theme.spacing.md};
    margin-bottom: ${theme.spacing.xxs};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: 0 ${theme.spacing.xxs};
    }
  `,

  backgroundContainerSubtitle: theme => css`
    text-align: center;
    padding: 0 ${theme.spacing.md};
    margin-top: ${theme.spacing.xs};

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      margin: 0 ${theme.spacing.xxs};
      padding: ${theme.spacing.xs} ${theme.spacing.xl};
    }
  `,

  backgroundContainerIcon: theme => css`
    padding: ${theme.spacing.xxs};
    z-index: 1;
    width: 80%;
    max-width: 398px;
    height: 398px;
    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      max-width: 320px;
      width: 100%;
    }
  `,

  backgroundNoise: css`
    position: absolute;
    background-image: url(${noise});
    background-position: center;
    background-size: cover;
    height: 100%;
    width: 100%;
  `,

  containerIcon: css`
    height: calc(100vh - ${IS_PRODUCTION ? '0px' : headerMUIU});
    flex-direction: row;
    display: flex;
    position: relative;
    @media screen and (max-height: 700px) {
      height: auto;
      min-height: 100vh;
    }
    @media screen and (max-width: 768px) {
      align-items: center;
      justify-content: center;
      height: auto;
      width: 100%;
      flex-direction: column-reverse;
    }
  `,

  containerBackground: theme => css`
    position: relative;
    width: 65%;
    height: calc(100vh - ${IS_PRODUCTION ? '0px' : headerMUIU});
    display: flex;

    background: linear-gradient(
      -45deg,
      ${theme.colors.brand.primary[300]},
      ${theme.colors.brand.primary[500]}
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    @media screen and (max-width: ${theme.grid.breakpoint.lg}) {
      width: 100%;
      min-height: 730px;
      justify-content: center;
      align-items: center;
      vertical-align: center;
    }
    @media screen and (max-height: 700px) {
      height: auto;
    }
  `,
})

export default useStyles
